module.exports = __webpack_public_path__ + "static/media/fit_after_40.c384f70b.jpg";